import React from 'react';
import './button.css';

var Button = function Button(props) {
	var url = props.url,
	    action = props.action,
	    text = props.text,
	    icon = props.icon;

	if (url) {
		return React.createElement(
			'a',
			{ href: url, className: 'button' },
			text,
			React.createElement(
				'span',
				null,
				icon
			)
		);
	} else {
		React.createElement(
			'button',
			{ onClick: action, className: 'button' },
			text,
			React.createElement('span', { dangerouslySetInnerHTML: { __html: icon } })
		);
	}
};

export default Button;